import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  ConfirmResult,
  ControlsApi,
  Log,
  warnAndToastSimpleResult,
} from "@ryde/shared";

import { useModalConfirm } from "../../hooks-singletons/use-modal-confirm";

export const useClearStaleRoutes = (): {
  handleClearStaleRoutesClick: () => Promise<void>;
} => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();

  const handleClearStaleRoutesClick = useEvent(async (): Promise<void> => {
    const confirmed = await confirmDialogResult({
      title: "Clear stale routes",
      message: "Do you want to clear stale routes?",
    });

    if (confirmed !== ConfirmResult.OK) {
      Log.infoAndToast("Clear stale routes canceled by user");
      return;
    }

    const clearStaleRoutesResult = await ControlsApi.clearStaleRoutes();

    if (clearStaleRoutesResult?.success) {
      const deletedCount = clearStaleRoutesResult.data || 0;
      Log.successAndToast(`Cleared ${deletedCount} stale route(s)`);
    } else if (clearStaleRoutesResult) {
      warnAndToastSimpleResult(clearStaleRoutesResult, t);
    } else {
      Log.errorAndToast("No response from api");
    }
  });

  return { handleClearStaleRoutesClick };
};
